const misc = require('./misc')
const { SPLIT_FEATURES } = require('./feature')

module.exports = {
  ...misc,
  SPLIT_FEATURES,
}
